
<div class="measure-components">
    <div class="measure-component-toggle"><mat-slide-toggle  labelPosition="before" [(ngModel)]="isShowAllComponents"></mat-slide-toggle></div>
    <div >   
        <div  class="accordion-list" *ngFor="let component of componentList">        
            <mat-accordion multi *ngIf="component.isMandatory || isShowAllComponents" >
                <mat-expansion-panel (opened)="createComponent(criteriaId ,component.componentId, component.id, component.name)">
                    <mat-expansion-panel-header>
                        <mat-panel-title> {{ component.name }} </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                        <ng-template matExpansionPanelContent>
                            <app-rules 
                                [criteriaId]="criteriaId" 
                                [ruleGroupId]="component.ruleGroupId" 
                                [componentId]="component.componentId">
                            </app-rules>
                            <div cdkDropList (cdkDropListDropped)="drop(component.componentId, $event)">   

                                @for (rule of component.ruleIdList; track rule; let index = $index) {
                                    <mat-accordion multi cdkDrag class="accordion-list" >
                                        <mat-expansion-panel> 
                                        <mat-expansion-panel-header>
                                            <mat-panel-title> {{ index + 1 }}  - Rule: {{ rule.id }}</mat-panel-title>
                                        </mat-expansion-panel-header>                            
                
                                            <app-rule-editor [editorID]="getEditorId(component.editorName, rule.id)" 
                                                [ruleId]="rule.id" 
                                                [isModal]="false"
                                                [criteriaId]="criteriaId" 
                                                [ruleGroupId]="component.ruleGroupId" 
                                                [componentId]="component.componentId">
                                            </app-rule-editor>
                                                        
                                        </mat-expansion-panel>            
                                    </mat-accordion>    
                                }
                            </div>
                        </ng-template>
                    </div>
                </mat-expansion-panel>        
            </mat-accordion>        
        </div>    
    </div>
</div>



                        